import { useNavigate, useLocation } from "react-router-dom";
import "./CtaBanner.css";

export default function CtaBanner() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (location.pathname === "/contact") {
      window.dispatchEvent(new Event("openContactModal"));
    } else {
      navigate("/contact");
      // Small delay to let the page render, then open modal
      setTimeout(() => {
        window.dispatchEvent(new Event("openContactModal"));
      }, 100);
    }
  };

  return (
    <section className="cta-banner">
      <div className="cta-banner__inner">
        <h3 className="cta-banner__title">轉化每一瞬，創造永恆之美</h3>
        <p className="cta-banner__text">
          如果您也在尋找一種剛剛好的樣子，歡迎預約設計諮詢
        </p>
        <button className="cta-banner__btn" onClick={handleClick}>
          預約設計諮詢 →
        </button>
      </div>
    </section>
  );
}
